module.exports = __webpack_public_path__ + "img/face17.4eac0838.gif";